module.exports = __webpack_public_path__ + "static/chuffed-02031832690719b2efa058ba0308af20.png";